import axios from 'axios';
var ajaxUrl = "".concat(window.location.origin, "/wp-admin/admin-ajax.php");
export var cartApi = {
    getCart: function () {
        return axios.get(ajaxUrl, {
            params: { action: 'ajax_get_cart' },
        });
    },
    applyCoupon: function (formData) {
        formData.append('action', 'ajax_apply_coupon');
        return axios.postForm(ajaxUrl, formData);
    },
    removeCoupon: function (code) {
        return axios.postForm(ajaxUrl, {
            action: 'ajax_remove_coupon',
            coupon_code: code,
        });
    },
    updateItemQuantity: function (key, qty) {
        return axios.postForm(ajaxUrl, {
            action: 'ajax_update_cart_item_quantity',
            cart_item_key: key,
            quantity: qty,
        });
    },
    toggleCoin: function (apply) {
        // The drawer has one authoritative SM Rewards control and endpoint.
        var input = document.querySelector('.mini-cart .mini-cart__coin-checkbox-input[data-sm-rewards-action]');
        var action = input === null || input === void 0 ? void 0 : input.dataset.smRewardsAction;
        var nonce = input === null || input === void 0 ? void 0 : input.dataset.smRewardsNonce;
        if ((input === null || input === void 0 ? void 0 : input.dataset.smRewardsEnabled) !== '1' || !action || !nonce) {
            return Promise.reject(new Error('ELF Coins sind derzeit nicht verfügbar.'));
        }
        return axios.postForm(ajaxUrl, {
            action: action,
            nonce: nonce,
            apply: apply ? 'true' : 'false',
        });
    },
    addToCart: function (item) {
        return axios.postForm(ajaxUrl, {
            action: 'ajax_add_to_cart',
            product_id: item.element.getAttribute('data-product'),
            variation_id: item.element.getAttribute('data-variation'),
            quantity: 1,
        });
    },
};
